// Animations
import './animations';

// FAQs page
import './_faqs';